import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SignatureManager from "../../components/SignatureManager";
import ReviewManager from "../../components/ReviewManager";
import CompanyAddress from "../../components/CompanyAddress";
import "../../styles/Form.css";
import logo from "../../images/logo.png";

const GatePassPolicy = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [username, setUsername] = useState("");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const [isSigned, setIsSigned] = useState(false);
  const [signedDate, setSignedDate] = useState("");
  const effectiveUserId = isAdmin && paramId ? paramId : userId;

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = isAdmin
          ? `${API_BASE}/api/users/${effectiveUserId}`
          : `${API_BASE}/api/user/profile`;

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { first_name, last_name } = res.data;
        setUsername(`${first_name} ${last_name}`);
      } catch (err) {
        console.error("Error fetching user name:", err);
      }
    };

    const fetchTaskStatus = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/usertasks/status/${effectiveUserId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const TASK_ID = 8; // verify this matches nwt_tasks.t_id for LEEP
        const idKey = String(TASK_ID);
        const nameKey = "gate_pass_policy";

        const status =
          res.data.status?.[idKey] ??
          res.data.status?.[nameKey] ??
          "not_completed";

        const signed = status === "review" || status === "completed";

        if (signed) {
          setIsSigned(true);
          setSignedDate(
            res.data.signdates?.[idKey] ?? res.data.signdates?.[nameKey],
          );
        }
      } catch (err) {
        console.error("Error checking task status:", err);
      }
    };

    fetchUserName();
    fetchTaskStatus();
  }, [API_BASE, userId, isAdmin, effectiveUserId]);

  const handleCancel = () => {
    if (isAdmin && paramId) {
      navigate(`/userhome/${paramId}`);
    } else {
      navigate("/userhome");
    }
  };

  return (
    <>
      {/* 🔝 Header Section with Status + Cancel Button */}
      <div className="d-flex justify-content-between align-items-center pt-3">
        <div className="d-flex align-items-center">
          <span className="me-2 text-danger"></span>
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Gate Pass Policy
          </span>
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Return
        </button>
      </div>
      <div
        className="form-wrapper my-4  print-area"
        style={{ fontSize: "15px", lineHeight: "1.6" }}
      >
        <div className="row align-items-center mb-4">
          <div className="col-3 text-start">
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <div className="col-6 text-center">
            <h2 className="m-0">Gate Pass Policy</h2>
          </div>
          <CompanyAddress />
        </div>

        <p className="mt-5">
          I <strong>{username}</strong>, hereby consent that I am getting the
          gate pass from New-Way Transport Inc. In future if I resign from the
          company, I would return my gate pass and in case I failed to do so I
          authorize them to deduct $150 from my pay.
        </p>

        <hr className="my-5" />

        <form>
          <div className="row mb-3 mt-5">
            <div className="col">
              <label className="form-label">Employee Name</label>
              <input
                type="text"
                className="form-control"
                value={username}
                readOnly
              />
            </div>
            <div className="col">
              <label className="form-label">Date</label>
              <input
                type="text"
                className="form-control"
                value={
                  isSigned && signedDate
                    ? new Date(signedDate).toLocaleDateString()
                    : new Date().toLocaleDateString()
                }
                readOnly
              />
            </div>
          </div>
        </form>

        {userId && (
          <>
            <SignatureManager
              taskName="gate_pass_policy"
              taskId={8}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
            <ReviewManager
              taskName="gate_pass_policy"
              taskId={8}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
          </>
        )}
      </div>
    </>
  );
};

export default GatePassPolicy;
